import { Injectable, signal } from "@angular/core";

export type AlertType = "success" | "error" | "warning" | "info";

export interface Alert {
  type: AlertType;
  message: string;
  id: number;
}

@Injectable({
  providedIn: "root",
})
export class AlertService {
  private currentId = 0;
  public readonly alerts = signal<Alert[]>([]);

  public showAlert(type: AlertType, message: string, duration = 5000): void {
    const id = this.getNextId();

    this.alerts.update(alerts => [...alerts, { type, message, id }]);

    setTimeout(() => {
      this.removeAlert(id);
    }, duration);
  }

  public removeAlert(id: number): void {
    this.alerts.update(alerts => alerts.filter(alert => alert.id !== id));
  }

  private getNextId(): number {
    return this.currentId++;
  }
}
